import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';

interface OverdueWellsListProps {
    wells: any[];
    isDarkMode: boolean;
    onSelectWell: (well: any) => void;
}

export function OverdueWellsList({ wells, isDarkMode, onSelectWell }: OverdueWellsListProps) {
    return (
        <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 1.2 }}
            className={`
        rounded-xl shadow-sm p-[1px]
        ${isDarkMode ? 'bg-gradient-to-br from-orange-500 to-red-600' : 'bg-transparent border border-gray-200'}
      `}
        >
            <div className={`p-4 rounded-xl h-full ${isDarkMode ? 'bg-slate-900' : 'bg-white'}`}>
                <h3 className={`text-lg font-semibold mb-4 flex items-center ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    <AlertTriangle className="h-5 w-5 mr-2 text-orange-600" />
                    Needs Attention ({wells.length})
                </h3>
                <div className="space-y-3">
                    {wells.slice(0, 3).map((well, index) => {
                        const daysSince = well.lastEntry
                            ? Math.floor((Date.now() - new Date(well.lastEntry).getTime()) / (1000 * 60 * 60 * 24))
                            : 999;

                        return (
                            <motion.div
                                key={well.id}
                                initial={{ opacity: 0, x: 10 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: 1.3 + index * 0.1 }}
                                whileHover={{ scale: 1.02 }}
                                onClick={() => onSelectWell(well)}
                                className={`
                  flex items-center justify-between p-3 rounded-lg cursor-pointer transition-colors
                  ${isDarkMode ? 'bg-slate-800 hover:bg-slate-700' : 'bg-orange-50 hover:bg-orange-100'}
                `}
                            >
                                <div className="flex-1">
                                    <p className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{well.name}</p>
                                    <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>{well.location || 'No location'}</p>
                                    <p className={`text-xs mt-1 ${isDarkMode ? 'text-orange-400' : 'text-orange-600'}`}>
                                        {well.lastEntry ? `${daysSince} days since last check` : 'Never checked'}
                                    </p>
                                </div>
                                <AlertTriangle className="h-5 w-5 text-orange-500 flex-shrink-0" />
                            </motion.div>
                        );
                    })}
                    {wells.length === 0 && (
                        <p className={`text-center py-4 ${isDarkMode ? 'text-gray-500' : 'text-gray-500'}`}>All wells are up to date!</p>
                    )}
                </div>
            </div>
        </motion.div>
    );
}
